var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c("yxt-switch", {
          attrs: { "active-value": 1, "inactive-value": 0 },
          model: {
            value: _vm.value.inside,
            callback: function ($$v) {
              _vm.$set(_vm.value, "inside", $$v)
            },
            expression: "value.inside",
          },
        }),
        _c("span", { staticClass: "tlive-create__tip" }, [
          _vm._v(
            "\n       \n      " +
              _vm._s(
                _vm.$t(
                  "pc_biz_openToEnterprisesAll" /* 对企业公开，所有员工通过链接或从“直播广场”观看 */
                )
              ) +
              "\n    "
          ),
        ]),
      ],
      1
    ),
    _c(
      "div",
      [
        _c("yxt-switch", {
          attrs: { "active-value": 1, "inactive-value": 0 },
          model: {
            value: _vm.value.publishType,
            callback: function ($$v) {
              _vm.$set(_vm.value, "publishType", $$v)
            },
            expression: "value.publishType",
          },
        }),
        _c("span", { staticClass: "tlive-create__tip" }, [
          _vm._v(
            "\n       \n      " +
              _vm._s(
                _vm.$t("pc_biz_broadcastLiveSquare" /* 发布到直播广场 */)
              ) +
              "\n    "
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }